var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-checkbox',{attrs:{"vb_options":{
    text: 'Bagagli inclusi',
    value:
      _vm.included_checked_bags_only === '1' || _vm.included_checked_bags_only === 1,
    type: 'light',
    switch: true,
  }},on:{"change":_vm.handle_change}})
}
var staticRenderFns = []

export { render, staticRenderFns }